import TriggerMappers from './_TriggerMappers';
import ActionMappers from './_ActionMappers';
export default {
  name: 'DataConnectorFeedEditor',
  props: ['feed_id'],
  components: {
    TriggerMappers: TriggerMappers,
    ActionMappers: ActionMappers
  },
  data: function data() {
    return {
      loading: true,
      all_actions: {},
      all_triggers: {},
      integrations: [],
      feed: false,
      saving: true
    };
  },
  methods: {
    fetch: function fetch() {
      var _this = this;
      this.loading = true;
      this.$get('feeds/' + this.feed_id, {
        "with": ['all_actions', 'all_triggers', 'integrations']
      }).then(function (response) {
        _this.feed = response.feed;
        _this.all_actions = response.all_actions;
        _this.all_triggers = response.all_triggers;
        _this.integrations = response.integrations;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.loading = false;
      });
    },
    updateFeed: function updateFeed() {
      var _this2 = this;
      this.saving = true;
      this.$put('feeds/' + this.feed_id, {
        feed: JSON.stringify(this.feed)
      }).then(function (response) {
        _this2.$notify.success(response.message);
        _this2.feed = response.feed;
      })["catch"](function (errors) {
        _this2.$handleError(errors);
      }).always(function () {
        _this2.saving = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
};